import "./RemoveButton.css"

export default function RemoveButton(props) {
    const onClick = props.onClick
    const text = props.children
    const extraClassName = props.extraClassName
    const disabled = props.disabled
    let className = "text-white font-bold py-2 px-4 rounded bg-red-500 hover:bg-red-700"
    className = [className, extraClassName].join(" ")
    return (
        <button
            className={className}
            onClick={onClick}
            disabled={disabled}
        >
            {text}
        </button>
    )
}